export default __webpack_public_path__ + "static/media/student-blue.62700586.svg";